export default __webpack_public_path__ + "static/media/tennis-red.d909521f.png";